import { withHandlers } from 'recompose';
import Auth from '@aws-amplify/auth';
import * as Sentry from '@sentry/browser';
import { Mixpanel } from 'utilities/mixpanel';
import { clearMultipleLocalStorage } from 'utilities/utilities';

const onLogout = ({ onChangeLogin, localStorage, customer_id }) => async event => {
  event.preventDefault();
  Sentry.addBreadcrumb(`User ${customer_id} Logged Out`);
  try {
    await Auth.signOut(); // Perform signout on Cognito
  } catch (err) {
    Sentry.captureException(err);
  }
  onChangeLogin(false); // Change state
  localStorage.clear(); // Cleanup local storage
  if (window) window.location.replace('http://www.coveinsurance.co.nz');
  return false;
};

const onStartOver = () => () => {
  Mixpanel.track('Clicked Start Over');
  Mixpanel.register({ Product: null });
  Sentry.addBreadcrumb(`User Started Over`);
  if (
    localStorage.getItem('cove-referral-code') == '68BB99' ||
    localStorage.getItem('cove-referral-code') == '9EB123' ||
    localStorage.getItem('cove-referral-code') == 'CFC8BF'
  ) {
    const refCode = localStorage.getItem('cove-referral-code');
    localStorage.clear();
    localStorage.setItem('cove-referral-code', refCode);
    Mixpanel.track('Cleared storage for Partner quote');
  }
  // clear the user's records

  clearMultipleLocalStorage(
    'cove-coverage-id',
    'cove-bound-quote-id',
    'cove-risk',
    'answers',
    'adjusted-quote',
    'amended-quote',
    'cove-quote-id'
  );

  if (window) {
    window.location.replace('/quote/product');
  }
};

const withNavBarHandler = withHandlers({
  onLogout,
  onStartOver
});

export default withNavBarHandler;
